// extracted by mini-css-extract-plugin
export default {"box_idleTimer":"idleTimerContainer_box_idleTimer__cqqe+","textAlign":"idleTimerContainer_textAlign__TYYY7","button_wrapper":"idleTimerContainer_button_wrapper__BZUJ4"};